import Segment from 'semantic-ui-react/dist/commonjs/elements/Segment'
export default Segment
